import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DwChildConfigBaseComponent, DwComponentSectionConfigPreference, DwConditionalFieldClasses, DwMdItem, DwMdSectionConfigBaseComponent2, DwMetaDataConfigContext } from '@devwareapps/devware-cap';
import { TimerCardClass } from '../../models/timer-card-class.model';
import { TimerConfig, TimerInterval } from '../../models/timer-config.model';
import { TimerUtilService } from '../../services/timer-util.service';

@Component({
  selector: 'app-timer-card-config',
  templateUrl: './timer-card-config.component.html',
  styleUrls: ['./timer-card-config.component.scss']
})
export class TimerCardConfigComponent extends DwChildConfigBaseComponent<TimerConfig, DwMetaDataConfigContext>  {
  cardClasses: TimerCardClass[];
  
  constructor(private timerUtilService: TimerUtilService) {
    super();

    this.cardClasses = timerUtilService.getTimerCardClasses();
  }

  getDefaultConfig(): TimerConfig {
    return {
      timerIntervals: [],
    };
  }

  addItem() {
    this.config.timerIntervals.push({
      cardClassKey : ''
    });
  }

  removeItem(timerInterval: TimerInterval) {
    const index = this.config.timerIntervals.indexOf(timerInterval);
    
    this.config.timerIntervals.splice(index,1);

    this.onChange();
  }

}
